import React from 'react';
import AppRoutes from './routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom-theme.css';

function App() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header__inner">
          <div className="app-brand">
            <div className="app-brand__mark">
              <img src={`${process.env.PUBLIC_URL}/logo1.png`} alt="Logo" className="app-brand__logo" />
            </div>
            <div>
              <p className="app-brand__eyebrow">Gestion operativa</p>
              <h1 className="app-brand__title">Turnos Web</h1>
            </div>
          </div>
          <div className="app-header__badge">Planificacion y control de ingresos</div>
        </div>
      </header>

      <main className="app-main">
        <AppRoutes />
      </main>
    </div>
  );
}

export default App;